  (function (angular, schoolwork12) {

    'use strict';

    angular.module(schoolwork12.app.auth.name).controller(schoolwork12.app.auth.controllers.login, ['$scope', '$location', schoolwork12.app.auth.services.authentication,
            function($scope, $location, authentication) {
                $scope.loginModel = {};
                $scope.isBusy = false;
                $scope.invalidLogin = false;
                //SIS-1581: Removed the pfKeyCode to avoid login issues
                document.cookie = "pfKeyCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.k12.com"

              $scope.login = function() {
                    $scope.invalidLogin = false;
                    $scope.isBusy = true;

                    //Todo call rest authenticate
                   var authPromise = authentication.authenticate($scope.loginModel.username,
                                               $scope.loginModel.password);

                    authPromise.then(function(data) {
                            console.info('authentication Promise:'.concat(data));
                            if (data){
                                $location.path(schoolwork12.app.student.routes.studentSearch);
                            }

                    }, function(error) {
                        if (error) {
                          console.info('Error in authentication Promise:'.concat(angular.toJson(error)));
                          $scope.invalidLogin = true;
                        }
                    })['finally'](function() { $scope.isBusy=false;});
            };
            }]);

}(angular, schoolwork12));
